module.exports = __webpack_public_path__ + "img/upload.2e1cc2d5.png";